<template>
  <div class="container d-grid-3 pdt-24 pdb-24 grid-gap-0">
    <div class="pdl-32 pdr-32 position-relative right-border pdb-16 pdt-16">
      <i class="material-icons mgr-6 t-color-bodyGrayA font-20 d-block" :class="`${direction === 'rtl' ? 'rtl': ''}`">timelapse</i>
      <div class="t-subtitle1 t-color-headlineBlack font-r l-spacing45 t-nowrap mgt-8">{{ $t('30107') }}</div>
      <div class="t-body3 t-color-bodyGrayA l-spacing48 font-r mgt-8 t-line-h-20" v-html="summaryInfo"></div>
    </div>
    <div class="pdl-32 pdr-32 position-relative right-border pdb-16 pdt-16">
      <i class="material-icons mgr-6 t-color-bodyGrayA font-20 d-block" :class="`${direction === 'rtl' ? 'rtl': ''}`">insert_chart</i>
      <div class="t-subtitle1 t-color-headlineBlack font-r l-spacing45 t-nowrap mgt-8">{{ $t('30110') }}</div>
      <div v-if="detailData.levels[0]" class="t-body3 t-color-bodyGrayA l-spacing48 font-r mgt-8 t-line-h-20" v-html="setLecture"></div>
    </div>

    <div class="pdl-32 pdr-32 position-relative right-border pdb-16 pdt-16">
      <i class="material-icons mgr-6 t-color-bodyGrayA font-20 d-block" :class="`${direction === 'rtl' ? 'rtl': ''}`">school</i>
      <div class="t-subtitle1 t-color-headlineBlack font-r l-spacing45 t-nowrap mgt-8"> {{ $t('30056')}} </div>
      <div class="t-body3 t-color-bodyGrayA l-spacing48 font-r mgt-8 t-line-h-20" v-html="setCertificate">
      </div>
    </div>

  </div>
</template>

<script>
import microCourseApi from "@/api/microCourseApi";
import {utilDateMixin} from "@/mixins/dateUtil";

export default {
  name: "Summary",

  props: ['detailData', 'certificateSet'],

  data() {
    return {
      // missionNumber: 0,
      direction:""
    }
  },

  computed: {
    summaryInfo() {
      const { sections, lessons, regularExams } = this.detailData.contentsCount;
	    const courseCnt = this.detailData.contents.filter(content => content.degreeContents).length;  // 과정은 무조건 있기 때문에 null 체크 안함
      const items = [
        { label: this.$t(courseCnt <= 1 ? '30214' : '30108', {str: `<span class="t-color-lectureRed">` + courseCnt + `</span>\n`}), value: sections },
        { label: this.$t(lessons <= 1 ? '30215' : '30109', {str: `<span class="t-color-lectureRed">` + lessons + `</span>\n`}), value: lessons },
      ];
      const validItems = items.filter(item => item.value > 0);
      const validTime = this.detailData.runningTime === 0 ? this.$t('30095') : this.$options.filters.timeToI18nFormat(this.detailData.runningTime);
      return validTime + `\n(` + (validItems.map(item => `${item.label}`).join(',\n')) + `)`;
    },
    setLecture() {
      return this.$t('30055', {str: `<span class="t-color-lectureRed">${this.detailData.levels[0].text}</span>`});
    },
    setCertificate() {
      if(this.isCertificate) {
        return this.$t('30057', {str: `<span class="t-color-lectureRed">${this.certificateSet[0].params.ISSUE_ORGANIZATION_NAME}</span>`});
      } else {
        return this.$t('696');
      }
    },
    isCertificate() {
      return !!this.certificateSet.length;
    }
  },

  mounted() {
    this.direction = document.querySelector('html').getAttribute('dir');
  },

  methods: {
  }
}
</script>

<style scoped>
.grid-gap-0{
  grid-gap: 0;
}
iframe html{
  overflow: hidden !important;
}
</style>
